import { disableScroll, enableScroll } from './scroll-lock'

// TODO: NTH pri zobrazeni a skryti transition pekny (podla vue, tam tie transition el)
function baseShow(activeElement, overlay, allowScroll) {
    overlay.dataset.activeElement = activeElement

    requestAnimationFrame(() => {
        overlay.classList.add('is-active')

        if (!allowScroll) {
            disableScroll()
        }
    })
}

function baseHide(activeElement, overlay) {
    if (activeElement !== overlay.dataset.activeElement) {
        return
    }

    overlay.classList.remove('is-active')

    if (document.body.classList.contains('is-overlayed')) {
        enableScroll()
    }

    delete overlay.dataset.activeElement
}

function showOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, document.querySelector('.js-overlay'), allowScroll)
}

function hideOverlay(activeElement) {
    baseHide(activeElement, document.querySelector('.js-overlay'))
}

function showHeaderOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, document.querySelector('.js-header-overlay'), allowScroll)
}

function hideHeaderOverlay(activeElement) {
    baseHide(activeElement, document.querySelector('.js-header-overlay'))
}

export { showOverlay, hideOverlay, showHeaderOverlay, hideHeaderOverlay }
